import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import moment from 'moment-timezone/moment-timezone';
import { BodyTextSmall } from '../typography/typography';

type OWCSContentProps = {
  title: string;
  subtitle: string;
};

type ApyPageDisclosureProps = {
  classes: ClassNameMap;
  discSection: OWCSContentProps;
};

function PageDisclosure(props: ApyPageDisclosureProps) {
  const [apyDisclosureDetials, setapyDisclosureDetials] = useState<OWCSContentProps>();
  const { classes, discSection } = props;
  const handleApyTitleDateChange = () => {
    if (typeof discSection === 'object') {
      const estTimeZone = moment.tz('America/New_York');
      const currentHour = moment(estTimeZone).format('HH:mm');
      let updatedDate: string;
      if (currentHour >= '06:00') {
        const replaceWithTodaysDate = estTimeZone.format('MM/DD/YYYY');
        updatedDate = discSection?.title.replace('dd/mm/yyyy', replaceWithTodaysDate);
      } else {
        const replaceWithPastDate = estTimeZone.subtract(1, 'days').format('MM/DD/YYYY');
        updatedDate = discSection?.title.replace('dd/mm/yyyy', replaceWithPastDate);
      }
      discSection.title = updatedDate;
      setapyDisclosureDetials(discSection);
    }
  };

  useEffect(() => {
    handleApyTitleDateChange();
  }, [discSection]);

  return (
    <div>
      {apyDisclosureDetials && (
        <Grid item className={classes.aoapyDescription}>
          <Grid item className={classes.apyTitle}>
            <BodyTextSmall data-test="text-apy-accounts-disclosure" className={classes.apyTextNote}>
              {apyDisclosureDetials?.title}
            </BodyTextSmall>
          </Grid>
          <Grid item className={classes.apyDescription}>
            <BodyTextSmall
              data-test="subtext-apy-accounts-disclosure"
              className={classes.apySubTextNotice}
            >
              {apyDisclosureDetials?.subtitle}
            </BodyTextSmall>
          </Grid>
        </Grid>
      )}
    </div>
  );
}

export default PageDisclosure;
